import React, { useMemo } from 'react';
import * as Styles from './ProductCard.styles';
import { ColorVariant } from './ProductCard.types';

type ColorVariantsProps = {
  activeVariantId: string | undefined;
  isSelectActive: boolean;
  variants: ColorVariant[];
  isSmallDesktop: boolean;
  colorVariantsNumber: number;
  onVariantClick?: (item: ColorVariant) => void;
  onProductClick?: (id?: string, isFromVariantsClick?: boolean) => void;
};

export function ColorVariants({
  activeVariantId,
  isSelectActive,
  variants,
  isSmallDesktop,
  colorVariantsNumber,
  onVariantClick,
  onProductClick,
}: ColorVariantsProps) {
  const variantsToShow = useMemo(() => {
    if (!variants) {
      return [];
    }

    const smallScreenLimit = isSmallDesktop ? 4 : 6;
    return (variants || []).slice(0, smallScreenLimit);
  }, [variants, isSmallDesktop]);

  return (
    <Styles.VariantContainer
      isSelectActive={isSelectActive}
      position="relative"
      gap="4px"
      display="flex"
      my="8px"
      height="26px"
    >
      {variantsToShow?.length > 0 && (
        <>
          {variantsToShow.map((variant: ColorVariant) => {
            const image = variant.image_url?.split('?')?.[0];
            const smallImage = `${image}?width=30`;

            return (
              <Styles.TooltipInfo
                key={variant.entity_id}
                PopperProps={{
                  disablePortal: true,
                }}
                title={variant.exact_color}
              >
                <Styles.VariantIcon
                  isActive={activeVariantId === variant.entity_id}
                  onClick={() => onVariantClick?.(variant)}
                >
                  <img
                    src={smallImage}
                    alt={variant.exact_color}
                    loading="lazy"
                    width="24"
                    height="24"
                  />
                </Styles.VariantIcon>
              </Styles.TooltipInfo>
            );
          })}
          {variants?.length > 6 && (
            <Styles.VariantLeft
              variant="body"
              onClick={() => onProductClick?.(undefined, true)}
            >
              +{colorVariantsNumber - variantsToShow?.length}
            </Styles.VariantLeft>
          )}
        </>
      )}
    </Styles.VariantContainer>
  );
}
